import React from "react";

class LeftSideSection extends React.Component {
  render() {
    let { expertSignupHeroImage } = this.props;

    expertSignupHeroImage = expertSignupHeroImage ? expertSignupHeroImage : "";

    return (
      <div className="col desktop-only">
        <div
          className="find-an-expert-left-side-section-background-image d-flex flex-column align-items-center justify-content-center"
          style={{
            height: "100%",
            backgroundImage: "url(" + expertSignupHeroImage + ")",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat"
          }}
        ></div>
      </div>
    );
  }
}

export default LeftSideSection;
